<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import { rules } from '@/utils/validators'

export default {
  name: 'OnboardingProfileName',
  mixins: [validationMixin],
  props: {
    user: { type: Object, required: true },
    submitting: { type: Boolean, default: () => false }
  },
  data() {
    return {
      rules,
      form: {
        firstName: '',
        lastName: ''
      }
    }
  },
  created() {
    // Event tracking
    const { once } = this.lodash
    const { logEvent } = this.$amplitude

    const firstNameAdded = once(() => {
      const props = { firstName: this.form.firstName }
      logEvent('Buyer Onboarding: First Name Added', props)
    })
    this.firstNameAdded = () => {
      if (this.form.firstName) firstNameAdded()
    }

    const lastNameAdded = once(() => {
      const props = { lastName: this.form.lastName }
      logEvent('Buyer Onboarding: Last Name Added', props)
    })
    this.lastNameAdded = () => {
      if (this.form.lastName) lastNameAdded()
    }

    // Prefill form
    const { firstName, lastName } = this.user
    this.form = { firstName, lastName }
  },
  methods: {
    submit() {
      if (this.submitting || this.$v.$invalid) return

      const data = this.form
      this.$emit('submit', data)
    }
  },
  validations: {
    form: {
      firstName: { required },
      lastName: { required }
    }
  }
}
</script>

<template>
  <div class="view-grid">
    <transition name="slide-up">
      <div class="mt-3">
        <!-- Onboarding Profile // Name -->
        <form @submit.prevent="submit()">
          <!-- Title -->
          <p class="subtitle-1 font-weight-medium mb-1">
            How should we call you?
          </p>
          <!-- Subtitle -->
          <p class="body-2">
            We'll use it to make sure we deliver the food to the right person
          </p>

          <!-- Name -->
          <div class="my-3">
            <v-text-field
              v-model.trim="form.firstName"
              :rules="[rules.required]"
              validate-on-blur
              class="secondary--text"
              label="First name"
              @blur="firstNameAdded"
            />

            <v-text-field
              v-model.trim="form.lastName"
              :rules="[rules.required]"
              validate-on-blur
              class="secondary--text"
              label="Last name"
              @blur="lastNameAdded"
            />
          </div>

          <!-- Action Buttons -->
          <div class="mt-5">
            <v-btn
              :loading="submitting"
              :disabled="$v.$invalid"
              type="submit"
              rounded
              depressed
              color="primary"
              class="px-10"
            >
              Next
            </v-btn>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<style lang="sass" scoped></style>
